export default [
  {
    path: '/chat-widget',
    name: 'chat-widget',
    component: () => import('@/views/chatWidget/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.updateChatWidget',
      navActiveLink: 'chat-widget',
      resource: 'customize-chat-widget',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.updateChatWidget',
          active: true,
        },
      ],
    },
  },
]
